var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5853 9.35938H2.80408C2.46841 9.35938 2.1465 9.22603 1.90915 8.98868C1.67179 8.75133 1.53845 8.42941 1.53845 8.09375C1.53845 7.75809 1.67179 7.43617 1.90915 7.19882C2.1465 6.96147 2.46841 6.82813 2.80408 6.82812H25.5853C25.921 6.82812 26.2429 6.96147 26.4803 7.19882C26.7176 7.43617 26.851 7.75809 26.851 8.09375C26.851 8.42941 26.7176 8.75133 26.4803 8.98868C26.2429 9.22603 25.921 9.35938 25.5853 9.35938ZM21.3666 15.2656H7.02283C6.68716 15.2656 6.36525 15.1323 6.12789 14.8949C5.89054 14.6576 5.7572 14.3357 5.7572 14C5.7572 13.6643 5.89054 13.3424 6.12789 13.1051C6.36525 12.8677 6.68716 12.7344 7.02283 12.7344H21.3666C21.7022 12.7344 22.0242 12.8677 22.2615 13.1051C22.4989 13.3424 22.6322 13.6643 22.6322 14C22.6322 14.3357 22.4989 14.6576 22.2615 14.8949C22.0242 15.1323 21.7022 15.2656 21.3666 15.2656ZM16.3041 21.1719H12.0853C11.7497 21.1719 11.4277 21.0385 11.1904 20.8012C10.953 20.5638 10.8197 20.2419 10.8197 19.9062C10.8197 19.5706 10.953 19.2487 11.1904 19.0113C11.4277 18.774 11.7497 18.6406 12.0853 18.6406H16.3041C16.6397 18.6406 16.9617 18.774 17.199 19.0113C17.4364 19.2487 17.5697 19.5706 17.5697 19.9062C17.5697 20.2419 17.4364 20.5638 17.199 20.8012C16.9617 21.0385 16.6397 21.1719 16.3041 21.1719Z",
    fill: "#213867"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6d4cdd76d366407947293553537b37e6.svg";
export { ForwardRef as ReactComponent };